import { createContext } from "react";

const DF_CO0005Context = createContext();

export { DF_CO0005Context };
